import React, { createContext, useState } from "react";

interface ConfigurationsContextType {
  langs: string[];
  setLangs: (langs: string[]) => void;
  schemas: {};
  setSchemas: (schemas: any) => void;
}

export const ConfigurationsContext = createContext<ConfigurationsContextType>({
  langs: [],
  setLangs: () => {},  
  schemas: {},
  setSchemas: () => {}
});



interface ConfigurationsProviderProps {
  children: React.ReactNode;
}

export const ConfigurationsProvider: React.FC<ConfigurationsProviderProps> = ({
  children,
}) => {
  const [langs, setLangs] = useState<string[]>([]);
  const [schemas, setSchemas] = useState({});

  const setInLocalstorage = (key: string, value: any) => {
    // Guardamos en localstorage con una fecha de expiración de 1 semana
    localStorage.setItem(
      key,
      JSON.stringify({
        value: {
          data: value,          
        },
        expiration: new Date().getTime() + 1000 * 60 * 60 * 24 * 7,
      })
    );
  };

  const setSchemaInLocalstorage = (value: any) => {
    // schemas debe ser siempre un objeto. El backend puede devolver "" u otro
    // valor inválido; normalizamos para que los consumidores (p. ej. PageForm,
    // que hace schemas[element.schema_slug]) no operen sobre un string.
    const normalized =
      value && typeof value === "object" && !Array.isArray(value) ? value : {};
    setSchemas(normalized);
    setInLocalstorage("schemas", normalized);
  };
  const setLangsInLocalstorage = (value: any) => {
    // El backend puede devolver una respuesta malformada (p. ej. prefijada por
    // output leakeado de PHP) que axios deja sin parsear como string en lugar de
    // como array. Normalizamos aqui para que ningun consumidor reciba un valor no
    // iterable (evita el crash "langs.map is not a function", visible en Firefox).
    const normalized = Array.isArray(value) ? value : [];
    setLangs(normalized);
    setInLocalstorage("langs", normalized);
  }

  const value = {
    langs,
    setLangs: setLangsInLocalstorage,
    schemas,
    setSchemas: setSchemaInLocalstorage
  };
  return (
    <ConfigurationsContext.Provider value={value}>
      {children}
    </ConfigurationsContext.Provider>
  );
};
